import React from "react";
import NafutelQueryString from "src/utils/nafutelQueryString";

const NafutelQueryContextContext = React.createContext({});

interface IProps {
  children: React.ReactNode;
}

function NafutelQueryStringContextProvider({ children }: IProps) {
  const [
    tags,
    query,
    pushQuery,
    pushMutilQuery,
    removeQuery,
    removeMutilQuery,
    forceUpdateQuery,
  ] = NafutelQueryString();

  return (
    <NafutelQueryContextContext.Provider
      value={{
        tags,
        query,
        pushQuery,
        pushMutilQuery,
        removeQuery,
        removeMutilQuery,
        forceUpdateQuery,
      }}
    >
      {children}
    </NafutelQueryContextContext.Provider>
  );
}

export { NafutelQueryContextContext, NafutelQueryStringContextProvider };
